import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import StyleDetails, { TabContainer } from './details'
import { useParkMapViewerContext } from '../../context/mapViewer'

const TabStyles = () => {
    const { path } = useRouteMatch()
    const { isLoaded } = useParkMapViewerContext()

    return (
        <TabContainer>
            <Switch>
                <Route exact path={path} component={() => (isLoaded ? <StyleDetails /> : <div />)} />
            </Switch>
        </TabContainer>
    )
}

export default TabStyles
